var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"test"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:" col-12 px-0 pb-4"},[_c('GmapMap',{staticStyle:{"width":"100%","height":"220px"},attrs:{"center":{lat: _vm.markers[0].position.lat, lng:  _vm.markers[0].position.lng},"options":{
                 zoomControl: true,
                 mapTypeControl: false,
                 scaleControl: false,
                 streetViewControl: false,
                 rotateControl: false,
                 fullscreenControl: false,
                 disableDefaultUi: false,
                    },"zoom":12}},_vm._l((_vm.markers),function(m,index){return _c('GmapMarker',{key:index,attrs:{"icon":{ url: m.icon,
              scaledSize: { width: 45, height: 45}   },"position":m.position}})}),1)],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }